import { ValueOf } from 'src/models/types/utility-types';

export type AprovacaoPrestacoesActionType = 'aprovar' | 'corrigir' | 'recusar';

export const AprovacaoPrestacoesLoadingKeys = {
  Default: 'aprovacao-prestacoes-multi',
  DetailsContent: 'detalhe-prestacao-multi',
  Action: (type: AprovacaoPrestacoesActionType): `${AprovacaoPrestacoesActionType}-acao-prestacao-multi` =>
    `${type}-acao-prestacao-multi`,
  Image: 'imagem-prestacao-multi',
  Classificacao: 'classificacao-prestacao-multi'
} as const;

export type AprovacaoPrestacoesDefaultLoadingKey = ValueOf<typeof AprovacaoPrestacoesLoadingKeys, 'Default'>;
export type AprovacaoPrestacoesActionLoadingKey = ValueOf<typeof AprovacaoPrestacoesLoadingKeys, 'Action'>;
export type AprovacaoPrestacoesLoadingKey = ValueOf<typeof AprovacaoPrestacoesLoadingKeys>;
